<template>
  <header class="px-8 header">
    <div class="d-flex justify-space-between align-center">
      <div style="height: 100px" class="d-flex align-center">
        <v-img
          v-if="!backToRoute"
          :src="logo"
          width="80"
          height="80"
          aspect-ratio="1"
          contain
          style="cursor: pointer"
          @click="
            $route.name != routeNames.WALLET &&
              $router.push({ name: routeNames.WALLET })
          "
        ></v-img>
        <v-icon
          v-else
          large
          color="primary"
          @click="goBack($router, backFrameRoute)"
          >arrow_back</v-icon
        >
      </div>
      <div v-if="!onlyLogoHeader">
        <div
          class="d-flex align-center"
          style="cursor: pointer"
          @click="
            $route.name != routeNames.MY_ACCOUNT &&
              $router.push({ name: routeNames.MY_ACCOUNT })
          "
        >
          <div class="mt-4 primary--text font-weight-light pr-1">
            {{ userName || this.$t("my_account.title") }}
          </div>
          <v-icon style="font-size: 45px; color: var(--primary-color)"
            >account_circle</v-icon
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import routeNames from "@/router/route-names";
import { mapState } from "vuex";
import { goBack } from "@/utils/commonMethods";

export default {
  props: {
    backToRoute: [Boolean],
    onlyLogoHeader: Boolean,
    backFrameRoute: String,
  },
  data() {
    return {
      routeNames: routeNames,
    };
  },
  methods: {
    goBack,
  },
  computed: {
    ...mapState({
      logo: (state) =>
        state.customization.customization
          ? state.customization.customization.logo
          : "/logo.png",
      userName: (state) => {
        if (!state.userData.userData) return null;
        const whole_username = state.userData.userData.name
          ? state.userData.userData.name
          : state.userData.userData.email.split("@")[0];
        return whole_username.length > 12
          ? `${whole_username.substr(0, 12)}...`
          : whole_username;
      },
    }),
  },
};
</script>
<style lang="css">
header {
  background-color: white !important;
}
.main-container {
  margin-top: 7.2rem !important;
}
.header {
  position: fixed;
  width: 100%;
  max-width: 500px;
  z-index: 1;
  padding-top: 1rem;
  height: 6.8rem;
}
</style>
